import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../NFe.Dto";

const NFeCadastroConsumidorFinalView = () => {
  const navigate = useNavigate();

  const consumidorFinalSelecionado = () =>
    getLocal<NFeDto>(STORAGENFE_KEY)?.consumidorFinal ?? undefined;

  const selecionado = consumidorFinalSelecionado() != undefined;

  const handleSalvar = (consumidor: number) => () => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      consumidorFinal: consumidor,
    });
    navigate("../destinooperacao");
  };

  const handleVoltar = () => () => {
    navigate("../destinatario");
  };

  const handleProximo = () => {
    navigate("../destinooperacao");
  };

  const buttonVariant = (consumidor: number) => {
    const selecionado = consumidorFinalSelecionado();

    if (selecionado === undefined || selecionado === consumidor) {
      return "primary";
    }

    return "outline-primary";
  };

  return (
    <>
      <Row>
        <Col xs={12} className="d-grid mt-3">
          <Button
            type="submit"
            onClick={handleSalvar(0)}
            variant={buttonVariant(0)}
          >
            0 - Normal
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="d-grid mt-3">
          <Button
            type="submit"
            onClick={handleSalvar(1)}
            variant={buttonVariant(1)}
          >
            1 - Consumidor Final
          </Button>
        </Col>
      </Row>
      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={!selecionado ? 12 : 6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar()}>
                Voltar
              </Button>
            </Col>
            {selecionado && (
              <Col xs={6} className="d-grid">
                <Button
                  variant="outline-primary"
                  type="submit"
                  onClick={handleProximo}
                >
                  Próximo
                </Button>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NFeCadastroConsumidorFinalView;
